import { AnimationEvent, useCallback, useEffect, useState } from 'react';

import {
  hasEmbedAiIntroPlayed,
  markEmbedAiIntroPlayed,
  prefersReducedMotion,
} from 'modules/ai/utils/embedAiIntroStorage';

const getInitialShouldAnimate = (): boolean => {
  if (hasEmbedAiIntroPlayed() || prefersReducedMotion()) {
    return false;
  }
  return true;
};

export const useEmbedAiIntro = () => {
  const [shouldAnimate, setShouldAnimate] = useState(getInitialShouldAnimate);

  useEffect(() => {
    if (!hasEmbedAiIntroPlayed() && prefersReducedMotion()) {
      markEmbedAiIntroPlayed();
    }
  }, []);

  const handleIntroEnd = useCallback(
    (event: AnimationEvent<HTMLDivElement>) => {
      if (!shouldAnimate || event.animationName !== 'navi-embed-reveal') {
        return;
      }
      markEmbedAiIntroPlayed();
      setShouldAnimate(false);
    },
    [shouldAnimate]
  );

  const rootClassName = shouldAnimate
    ? 'navi-embed navi-embed--intro'
    : 'navi-embed';

  return {
    shouldAnimate,
    handleIntroEnd,
    rootClassName,
  };
};
